export enum SessionEnumeration {
  CUSTOMER_SESSION_ID = 'csid',
  MODAL_DOWNLOAD_APP_OPENED_SESSION_KEY = 'modalDownloadAppHasBeenOpened',
}
